/* SETTINGS */
export const GET_SETTINGS = "GET_SETTINGS"
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS"
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL"

/* UPDATE SETTINGS */
export const UPDATE_SETTING = "UPDATE_SETTING"
export const UPDATE_SETTING_SUCCESS = "UPDATE_SETTING_SUCCESS"
export const UPDATE_SETTING_FAIL = "UPDATE_SETTING_FAIL"

